import axios from 'axios';

import Component from '@/scripts/core/Component';

class LazyBlock extends Component {
  onInit() {
    const {
      endpoint,
    } = this.$props;

    if (!endpoint) return;

    axios.get(endpoint)
      .then(({ data }) => {
        this.insertHTML(data);
      })
      .catch((err) => {
        // TODO: how to handle?
        console.error(err);
      });
  }

  insertHTML(html) {
    if (this.$el) {
      this.$el.innerHTML = html;
    }

    if (window.App && typeof window.App.initModules === 'function') {
      window.App.initModules();
    }
  }

  onDestroy() {}
}

export default LazyBlock;
